import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import { CREATE_VIEW_FORM } from "features/planner/planner.constants";

import {
  onEnterCreateView,
  createViewOnSubmit,
} from "features/planner/planner.actions";

import SimpleFormModal from "app/components/SimpleFormModal";
import CreateViewForm from "features/planner/components/View/CreateViewForm";

class CreateViewModal extends PureComponent {
  render() {
    const {
      children,
      dispatchCreateViewOnSubmit,
      dispatchOnEnterCreateView,
    } = this.props;

    return (
      <SimpleFormModal
        Trigger={children}
        title="Create view"
        submitText="Create"
        component={CreateViewForm}
        onEnter={dispatchOnEnterCreateView}
        onSubmit={dispatchCreateViewOnSubmit}
        form={{
          destroyOnUnmount: false,
          form: CREATE_VIEW_FORM.ID,
        }}
      />
    );
  }
}

export default compose(
  connect(
    null,
    {
      dispatchOnEnterCreateView: onEnterCreateView,
      dispatchCreateViewOnSubmit: createViewOnSubmit,
    },
  ),
)(CreateViewModal);
